import { render, staticRenderFns } from "./appMessageModal.vue?vue&type=template&id=01cc6625&"
import script from "./appMessageModal.vue?vue&type=script&lang=js&"
export * from "./appMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports